const completeNavLinks = [
  {
    type: "Services",
    links: [
      {
        text: "Tax Services",
        href: "/services/tax-services/",
      },
      {
        text: "Tax Consulting",
        href: "/services/tax-consulting/",
      },
      {
        text: "Accounting Services",
        href: "/services/accounting-services/",
      },
      {
        text: "Capital Gains Tax",
        href: "/services/capital-gains-tax/",
      },
    ],
  },
  {
    type: "Industries",
    links: [
      {
        text: "Real Estate",
        href: "/industries/real-estate/",
      },
      {
        text: "Law Firms & Lawyers",
        href: "/industries/law-firms/",
      },
      {
        text: "Dental",
        href: "/industries/dental/",
      },
      {
        text: "Healthcare",
        href: "/industries/healthcare/",
      },
      {
        text: "Small Businesses",
        href: "/industries/small-businesses/",
      },
    ],
  },
  {
    type: "Cannabis",
    links: [
      {
        text: "Cultivation Organization Licenses",
        href: "/cannabis/cultivation-license/",
      },
      {
        text: "Retail Sales Tax Structure",
        href: "/cannabis/retail-sales/",
      },
      {
        text: "Scoring Criteria for Applications",
        href: "/cannabis/scoring-criteria/",
      },
      {
        text: "Dispensing Organization Licenses",
        href: "/cannabis/dispensing-license/",
      },
    ],
  },
];

const serviceLinks = [];
const industryLinks = [];

// Iterate over the completeNavLinks to distribute the links accordingly
completeNavLinks.forEach((item) => {
  if (item.type === "Services") {
    serviceLinks.push(...item.links);
  } else if (item.type === "Industries") {
    industryLinks.push(...item.links);
  } else if (item.type === "Cannabis") {
    industryLinks.push({
      text: "Cannabis",
      href: item.links[0].href,
    });
  }
});

const headerLinks = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "About us",
    href: "/about",
  },
  {
    title: "Services",
    href: "#",
    dropdownLinks: serviceLinks,
  },
  {
    title: "Industries",
    href: "#",
    dropdownLinks: industryLinks,
  },
  {
    title: "Blog",
    href: "/blog",
  },
  {
    title: "Schedule a consultation",
    href: "https://go.oncehub.com/RENATABLIUMAITE",
  },
];

export { headerLinks, completeNavLinks };

// OLD METHOD: keep for reference
// const serviceLinks = [];
// completeNavLinks.forEach((link) => {
//   if (link.type === "Cannabis") {
//     serviceLinks.push({
//       text: "Cannabis Tax Services",
//       links: link.links,
//     });
//   } else {
//     serviceLinks.push(...link.links);
//   }
// });
